//#region src/dom/direction.ts
/**
* Check whether an element's text direction is right-to-left.
*
* @internal
*/
function isRTL(element) {
	const dir = element.closest("[dir]")?.getAttribute("dir")?.toLowerCase();
	if (dir === "rtl" || dir === "ltr") return dir === "rtl";
	return getComputedStyle(element).direction === "rtl";
}
//#endregion
export { isRTL };

//# sourceMappingURL=direction.js.map